"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CartProvider = exports.CartContext = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const reducers_1 = require("../reducers");
const CartStrategyProvider_1 = require("./CartStrategyProvider");
const ShoppingBagProvider_1 = require("./ShoppingBagProvider");
exports.CartContext = (0, react_1.createContext)({
    state: reducers_1.cartInitialState,
    dispatch: () => null,
});
const CartProvider = ({ children, shoppingBag, cart, }) => {
    const { initialState, reseller, cycle, uf } = cart || {};
    const [stateFromReducer, dispatchFromReducer] = (0, react_1.useReducer)(reducers_1.cartReducer, initialState || Object.assign(Object.assign({}, reducers_1.cartInitialState), { resellerData: reseller, cycleData: cycle, uf: uf }));
    (0, react_1.useEffect)(() => {
        dispatchFromReducer((0, reducers_1.actionSetMetaData)({ reseller, cycle, uf }));
    }, [uf, reseller, cycle]);
    return ((0, jsx_runtime_1.jsx)(ShoppingBagProvider_1.ShoppingBagProvider, Object.assign({}, shoppingBag, { children: (0, jsx_runtime_1.jsx)(exports.CartContext.Provider, Object.assign({ value: { state: stateFromReducer, dispatch: dispatchFromReducer } }, { children: (0, jsx_runtime_1.jsx)(CartStrategyProvider_1.CartStrategyProvider, Object.assign({ shouldClearCart: cart === null || cart === void 0 ? void 0 : cart.shouldClearCart }, { children: children })) })) })));
};
exports.CartProvider = CartProvider;
